const types = {
    AlphabetsOnly: /[^a-zA-Z\s]/g,
    AlphaAndNumbers: /[^a-zA-Z0-9\s]/g,
    AlphaAndNumbersAndUnderScore: /[^a-zA-Z0-9_\s]/g,
    NumbersOnly: /[^0-9]/g,
    Email: /[^a-zA-Z0-9@._-]/g,
    NamewithSplChar: /[^a-zA-Z0-9_\-'\.,&\/\(\)\+\*@\s]/g,
    HTTPSUrl: /[^a-zA-Z0-9:/?&=._-]/g,
    SOAPUsername: /[^a-zA-Z0-9_.-\s]/g,
    SAPOData: /[^a-zA-Z0-9_.!$*'()-\s]/g,
}

export const inputLengthVerify = ({ type, length = 10, value }) => {
    let finalValue;
    if (types[type]) {
        finalValue = value.replace(types[type], "");
    }
    else {
        finalValue = value;
    }

    if (finalValue.length < length) {
        return finalValue;
    }
    else {
        return finalValue.slice(0, length);
    }
}